<app-lista-adicionais [catalogo]="empresa.catalogo" [empresa]="empresa"  [objetoComAdicionais]="empresaComAdicionais"
                      [tela]="this" [servicoSalvarAdicional]="adicionalPedidoService" [naoPermiteCopiar]="true">
</app-lista-adicionais>
